export default "__VITE_ASSET__CZ0K4gjL__"